import React from "react";
import Sidebar from "./Sidebar";
import "../styles/Layout.css";
import SessionManager from "./SessionManager"; // ✅ import
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="layout">
      <Sidebar />
      <main className="content">
        <SessionManager /> {/* ✅ Active session tracking */}
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;